
      import '@folkjs/labs/standalone/folk-shape';
      import '@folkjs/labs/standalone/folk-arrow';

      document.body.querySelectorAll('folk-shape').forEach((el, i) => (el.style.viewTransitionName = `g${i}`));
      document.body.querySelectorAll('folk-arrow').forEach((el, i) => (el.style.viewTransitionName = `c${i}`));
      document.body.querySelectorAll('h2').forEach((el, i) => (el.style.viewTransitionName = `h${i}`));
      document.body.querySelectorAll('p').forEach((el, i) => (el.style.viewTransitionName = `p${i}`));

      const range = document.querySelector('input');

      range.addEventListener('input', (e) => {
        const currentZoom = range.valueAsNumber;
        let semanticZoom;

        if (currentZoom < 20) {
          semanticZoom = 0;
        } else if (currentZoom < 80) {
          semanticZoom = 50;
        } else {
          semanticZoom = 1;
        }

        if (semanticZoom !== Number(document.body.getAttribute('zoom'))) {
          document.startViewTransition(() => {
            document.body.setAttribute('zoom', semanticZoom);
          });
        }
      });
    